// src/api/mock/settingsData.js
export const settingsMockData = {
 id: 1,
  appName: "Siloam Cardiac Summit 2026",
  logoUrl: "", 
  logoFooterUrl:"",
  bannerUrl: "",
  companyName: "Nama Perusahaan Anda  ",
  themeColor: "#005baa",
  contactEmail: "", 
  officialWebsite: "",  
  address: "Gedung Perusahan anda Lt. 30, Alamat perusahan anda No. 15, Kota, Indonesia",
  phone: "+62 881362443808",
  updatedAt: "2026-05-02",
  aboutWelcomeNotes: [
    {
      id: 1,
      name: "Prof. Dr. Andri Sebastian, MD, PhD, FESC, FACC, FIHA",
      role: "Chairman Siloam Cardiac Summit 2026",
      image: "",
      title: "Welcome Note",
      message: `Dear Respected Colleagues and Esteemed Delegates,
      
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.

Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris..`,
    },
    {
      id: 2,
      name: "Prof. Dr. dr. Andri Sebastian, Sp.JP(K), FIHA, FAPSIC, FAsCC, FSCAI",
      role: "Chair I, Scientific Committee Siloam Cardiac Summit 2026",
      image: "", // Akan otomatis menggunakan DefaultNoPhoto
      title: "Welcome Note",
      message: `It is my great honor to welcome you to the event Summit.

TLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.

Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris.`,
    },
  ],  
};